export default "__VITE_ASSET__DB441gGV__"